import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../App';
import { initiateConsent } from '../../Services/PFMClient/ConsentService';
import { ROUTES } from '../../Utils/routes';
import {
  getPfmType,
  getUserId,
  setReferenceId,
} from '../../Utils/storageUtils';

export const enum AASTEPS {
  FIP_SELECTION,
  CONSENT_CREATION,
  AA_JOURNEY,
  AA_JOURNEY_COMPLETED,
}

const AA: React.FC<{ isError: any }> = ({ isError }) => {
  const [AAInternalStep, setAAInternalStep] = useState(
    AASTEPS.CONSENT_CREATION
  );
  const { navigateToDashboard, setIsLoading, isLoanJourneyDone }: any =
    useContext(AppContext);
  const [redirectionURL, setRedirectionURL] = useState('');
  const gotoRoot = () => {
    navigateToDashboard();
  };

  const handleSDKEvents = (event: any) => {
    if (event.data.eventCode === 'IFRAME_SUCCESS') {
      setIsLoading(false);
    } else if (
      event.data.eventCode === 'CONSENT_APPROVED_SUCCESS' ||
      event.data.eventCode === 'JOURNEY_COMPLETED'
    ) {
      if (!isLoanJourneyDone.current) {
        setTimeout(() => {
          gotoRoot();
        }, 3000);
      }
    }
  };

  const createConsentForUser = async () => {
    try {
      const initiateConsentResponse: any = await initiateConsent({
        userId: getUserId(),
      });

      if (initiateConsentResponse?.data === 'ERROR') {
        isError();
        return;
      }

      let queryParams;

      if (getPfmType()) {
        queryParams = '?isYesBankDemo=true&isYesBankDemoPFMJourney=true';
      } else {
        queryParams = '?isYesBankDemo=true';
      }
      setReferenceId(initiateConsentResponse.data.referenceId);
      setRedirectionURL(
        `${initiateConsentResponse.data.redirectionUrl + queryParams}`
      );
      setAAInternalStep(AASTEPS.AA_JOURNEY);
    } catch (e: any) {}
  };

  useEffect(() => {
    window.addEventListener('message', handleSDKEvents);
    createConsentForUser();
    return () => {
      window.removeEventListener('message', handleSDKEvents);
    };
  }, []);

  const renderAAJourney = () => {
    return (
      <iframe
        className='displaySize'
        src={redirectionURL}
        style={{
          border: 'none',
          height: '100%',
          // position: 'absolute',
          top: 0,
          left: 0,
        }}
        title='aa-iframe'
      />
    );
  };

  const renderComponents = () => {
    switch (AAInternalStep) {
      case AASTEPS.CONSENT_CREATION:
        return <></>;
      case AASTEPS.AA_JOURNEY:
        return renderAAJourney();
      case AASTEPS.AA_JOURNEY_COMPLETED:
        return <></>;
    }
  };

  return <>{renderComponents()}</>;
};

export default AA;
